import {
  BasePopover,
  Button,
  Content,
  Flex,
  fromTheme,
  StrokeIcon,
} from '@acsbe/ui';
import styled from 'styled-components';
import { useApplicationViewState, useDomainSelection } from '../../../context';
import { PlanFeature } from './plan-features';

interface PlanFeatureListProps {
  features: PlanFeature[];
  header?: boolean;
}

const PlanFeatureList = ({ features, header }: PlanFeatureListProps) => {
  const { showPlanComparisonView } = useApplicationViewState();

  const { isCustomDiscount } = useDomainSelection();

  const List = () => {
    return (
      <Flex gap={0}>
        {features.map((feature, index) => (
          <FeatureCell key={index} row justify="space-between">
            <Content size="sm" variant="element" lineHeight={1.5}>
              {feature.title}
            </Content>
            {feature.info ? (
              <BasePopover
                side="top"
                data-fit
                trigger={
                  <Button variant="link">
                    <StrokeIcon name="InfoMarkWithCircle" />
                  </Button>
                }
              >
                <Flex maxWidth="318px">
                  <Content variant="element">{feature.info}</Content>
                </Flex>
              </BasePopover>
            ) : (
              <StrokeIcon
                name="CheckWithCircle"
                style={{ paddingInline: '6px' }}
              />
            )}
          </FeatureCell>
        ))}
      </Flex>
    );
  };

  if (header && showPlanComparisonView) {
    return (
      <Flex gap={4} paddingBlock={4}>
        <Flex height={isCustomDiscount ? '189px' : '133px'} />
        <Flex height="40px">
          <FeatureHeading>Features</FeatureHeading>
        </Flex>
        <List />
      </Flex>
    );
  } else if (showPlanComparisonView) {
    return (
      <Flex gap={0}>
        {features.map((feature, index) => (
          <FeatureCell key={index} row justify="center">
            <Content size="sm" variant="element" lineHeight={1.5}>
              {feature.title && feature.title.length > 0 ? (
                feature.value ? (
                  feature.value
                ) : (
                  <StrokeIcon name="Check" size={12} />
                )
              ) : (
                '-'
              )}
            </Content>
          </FeatureCell>
        ))}
      </Flex>
    );
  } else {
    return (
      <Flex gap={5}>
        {features.map((feature, index) => (
          <Flex key={index} row justify="space-between">
            <Flex row gap={2} align="center">
              <StrokeIcon name="Check" size={12} />
              <Content size="sm" variant="element">
                {feature.title}
              </Content>
            </Flex>
            {feature.info ? (
              <BasePopover
                side="top"
                data-fit
                trigger={
                  <Button variant="link">
                    <StrokeIcon name="InfoMarkWithCircle" />
                  </Button>
                }
              >
                <Flex maxWidth="318px">
                  <Content variant="element">{feature.info}</Content>
                </Flex>
              </BasePopover>
            ) : (
              <StrokeIcon
                name="CheckWithCircle"
                style={{ paddingInline: '6px' }}
              />
            )}
          </Flex>
        ))}
      </Flex>
    );
  }
};

const FeatureHeading = styled(Content)`
  font-size: 20px;
  font-weight: 500;
  padding-inline: 16px;
`;

const FeatureCell = styled(Flex)`
  border-bottom: 1px solid #e8ebf3;
  padding-block: 8px;
  padding-inline: 16px;
  height: 38px;
  box-sizing: border-box;
  align-items: center;
  @media ${fromTheme('viewport.uptoDesktopXs')} {
    height: 56px;
  }
`;

export { PlanFeatureList };
